import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=41aaa190&scoped=true&"
import script from "./customPage.vue?vue&type=script&lang=js&"
export * from "./customPage.vue?vue&type=script&lang=js&"
import style0 from "./customPage.vue?vue&type=style&index=0&id=41aaa190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aaa190",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon})
